import { useRef, type ReactNode } from "react";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import type { ActivityFilterTab } from "./activityFilters.types";
import { ActivityFilters } from "./ActivityFilters";
import styles from "./ActivityFilters.module.scss";

interface ActivityFiltersBarProps {
    search: string | undefined;
    onSearchChange: (search: string | undefined) => void;
    tabs: readonly ActivityFilterTab[];
    onClearFilters?: () => void;
    /** The right-hand controls: density, the date button, then Entities or Clients. */
    children: ReactNode;
}

/** An Activity page's toolbar: Search, the Filter button and chips, then `children`. */
export const ActivityFiltersBar = ({
    search,
    onSearchChange,
    tabs,
    onClearFilters,
    children,
}: ActivityFiltersBarProps) => {
    const filtersContainerRef = useRef<HTMLDivElement>(null);
    return (
        <TablePageHeader
            isFullPage
            borderBottom
            filterContainerClassName={styles.toolbar}
            filtersContainerRef={filtersContainerRef}
            search={search}
            onSearchChange={(value) => onSearchChange(value || undefined)}
            afterFiltersChildren={
                <ActivityFilters
                    tabs={tabs}
                    onClearFilters={onClearFilters}
                    filtersContainerRef={filtersContainerRef}
                />
            }
        >
            {children}
        </TablePageHeader>
    );
};
